export default __webpack_public_path__ + "images/conmebol-libertadores-solid.261d13.png";